// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Bottom_wrapper__113J1","link":"Bottom_link__3D-jx"};